import { gsap } from 'gsap';

export default class RevealBio {

	constructor(el) {
		this.el = el;

        this.button = this.el.querySelector('[data-readbio-button]');

		if(!this.button) {
			return;
		}

		this.readmoreEl = this.el.querySelector('[data-readbio-element]');
        this.itemText = this.el.querySelector('[data-readbio-content]');

		this.button.addEventListener('click', () => {
            this.toggle();
        });

		const mm = gsap.matchMedia();

		mm.add('(max-width: 991px)', () => {
			this.tl = gsap.timeline({reversed: true, paused:true})
				.to(this.itemText, {
					height: "auto",
					duration: 0.5,
					ease: 'cubic.inOut',
				})
				.to(this.itemText, {
					autoAlpha: 1,
				})
		});

	}

	toggle() {
		if(!this.tl) {
			return;
		}
		this.tl.reversed() ? this.tl.play() : this.tl.reverse();

		if(this.tl.reversed()) {
			this.button.innerHTML = 'Read bio &nbsp;&nbsp;+';
		} else {
			this.button.innerHTML = 'Close bio &nbsp;&nbsp;-';
		}
    }
}